import { PersonAddressType } from 'types/address.type'
import { DocumentType } from 'types/document.type'
import {
  HearingIdentificationType,
  TeenagerIdentificationType,
} from 'types/hearing-identification.type'
import { InfractionType } from 'types/infraction.type'
import { HearingNarrativesType } from 'types/hearing-narratives.type'
import { PhoneType } from 'types/phone.type'
import { toBR } from 'utils/date.util'
import { validateField } from 'utils/validate.util'
import { SocialNetworkType } from 'types/social-network.type'

export const validateFieldName = (data: HearingIdentificationType): string => {
  if (!data) return ''
  return validateField(data.nome)
}

export const validateFieldSocialName = (data: HearingIdentificationType): string => {
  if (!data) return ''
  return validateField(data.nomeSocial)
}

export const validateArrestedType = (field?: string | null): string => {
  const validatedField = validateField(field)
  return validatedField === 'N' ? 'LIBERADO' : validatedField === 'S' ? 'APREENDIDO' : ''
}

export const validateStringNumber = (field?: string | null | number): string =>
  field && field !== 'null' && field !== '0' && String(field) !== '0' ? String(field) : ''

export const validateChoiceField = (field?: string | null): string => {
  const formattedField = validateField(field)
  return formattedField === 'S' ? 'Sim ' : formattedField === 'N' ? 'Não' : ''
}

export const validateChoiceStudingField = (field?: string | null): string => {
  if (!field) {
    return ''
  }

  if (field === 'S') {
    return 'Sim'
  } else if (field === 'E') {
    return 'Evadiu'
  } else if (field === 'C') {
    return 'Concluiu'
  } else {
    return ''
  }
}

export const formatInfraction = (item: InfractionType, index: number): string => {
  if (item) {
    const legalItems = [
      item.artigo && `Artigo: ${item.artigo}`,
      item.paragrafo && `Parágrafo: ${item.paragrafo}`,
      item.inciso && `Inciso: ${item.inciso}`,
      item.alinea && `Alínea: ${item.alinea}`,
      item.tipo && item.tipo.id !== '0' && `Tipo: ${item.tipo.descricao}`,
      item.lei && `Lei: ${item.lei}`,
      item.ano && `Ano: ${item.ano}`,
    ].filter(Boolean)

    const formattedItems = legalItems.length > 0 ? `${index + 1}) ${legalItems.join('; ')}.` : ''

    return formattedItems
  }
  return ''
}

export const validateBirthday = (data?: HearingIdentificationType): string => {
  if (!data) {
    return ''
  }
  return toBR(data.dataNascimento)
}

export const validateInfractionList = (data: HearingIdentificationType): InfractionType[] => {
  if (data && data.identificacaoAdolescente && data.identificacaoAdolescente.atoInfracionais) {
    return data.identificacaoAdolescente.atoInfracionais
  } else {
    return []
  }
}

export const validateNarrativeInfractionList = (data: HearingNarrativesType): InfractionType[] => {
  if (data && data.atoInfracionais) {
    return data.atoInfracionais
  } else {
    return []
  }
}

export const validatePhoneList = (data: HearingIdentificationType): PhoneType[] => {
  if (data && data.telefones) {
    return data.telefones
  } else {
    return []
  }
}

export const validateSocialNetworkList = (data: HearingIdentificationType): SocialNetworkType[] => {
  if (data && data.redesSociais) {
    return data.redesSociais
  } else {
    return []
  }
}

export const validateDocumentList = (data: HearingIdentificationType): DocumentType[] => {
  if (data && data.documentos) {
    return data.documentos
  } else {
    return []
  }
}

export const validateAddressList = (data: HearingIdentificationType): PersonAddressType[] => {
  if (data && data.enderecos) {
    return data.enderecos
  } else {
    return []
  }
}

export const formatWelcomedOtherReasons = (item: TeenagerIdentificationType): string => {
  if (!item) {
    return ''
  }

  const idDescriptionReason = validateField(item.descricaoidMotivoAcolhidoInstitucionalmente)
  const reason = validateField(item.descricaoMotivoAcolhidoInstitucionalmente)

  if (idDescriptionReason !== 'Outros') {
    return idDescriptionReason
  } else {
    if (idDescriptionReason === 'Outros' && reason && reason !== '') {
      return `${idDescriptionReason} - ${reason}`
    } else if (idDescriptionReason === 'Outros') {
      return idDescriptionReason
    }
  }

  return ''
}
